<template>
  <div class="birth-month-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Birth Month Section -->
    <section class="birth-month-section">
      <div class="container">
        <div class="birth-month-content">
          <PageTitle title="Birth Month" />
          
          <div class="months-grid">
            <button 
              v-for="month in months" 
              :key="month.value"
              :class="['month-button', { 'selected': selectedMonth === month.value }]"
              @click="selectMonth(month.value)"
            >
              {{ month.name }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'BirthMonthPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedMonth: null,
      userQuoteData: null,
      months: [
        { value: 1, name: 'January' },
        { value: 2, name: 'February' },
        { value: 3, name: 'March' },
        { value: 4, name: 'April' },
        { value: 5, name: 'May' },
        { value: 6, name: 'June' },
        { value: 7, name: 'July' },
        { value: 8, name: 'August' },
        { value: 9, name: 'September' },
        { value: 10, name: 'October' },
        { value: 11, name: 'November' },
        { value: 12, name: 'December' }
      ]
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 加载之前选择的出生月份（如果有的话）
          if (this.userQuoteData.birth_month !== undefined) {
            this.selectedMonth = this.userQuoteData.birth_month
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectMonth(monthValue) {
      this.selectedMonth = monthValue
      
      // 检查是否是添加驾驶员模式
      if (this.userQuoteData.adding_driver && this.userQuoteData.temp_driver) {
        // 添加驾驶员模式：更新临时驾驶员数据
        this.userQuoteData.temp_driver.birth_month = monthValue
        console.log('Selected birth month for additional driver:', monthValue)
      } else {
        // 主驾驶员模式：更新主驾驶员数据
        this.userQuoteData.birth_month = monthValue
        console.log('Selected birth month for primary driver:', monthValue)
      }
      
      this.saveUserData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('birthmonth')
      // 跳转到出生日期选择页面
      this.$router.push('/birth-day')
    },
    
    goBack() {
      this.$router.push('/married')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.birth-month-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Birth Month Section */
.birth-month-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.birth-month-content {
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
}

.months-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.month-button {
  padding: 1rem 0.5rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.month-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.month-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .birth-month-content {
    padding: 0 1rem;
  }

  .months-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }

  .month-button {
    padding: 1rem;
    font-size: 0.9rem;
    min-height: 55px;
  }

  .birth-month-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .months-grid {
    gap: 0.6rem;
  }

  .month-button {
    padding: 0.9rem;
    font-size: 0.85rem;
    min-height: 50px;
  }

  .birth-month-section {
    padding: 1rem 0;
  }
}
</style>
